import styled, { css } from 'styled-components';
import type { AvatarShape, AvatarSize } from './types';

interface RootProps {
    $size: AvatarSize;
    $shape: AvatarShape;
    $disabled?: boolean;
    $clickable?: boolean;
}

export const AvatarRoot = styled.div<RootProps>`
    position: relative;
    isolation: isolate;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${props => props.$size}px;
    height: ${props => props.$size}px;
    min-width: ${props => props.$size}px;
    min-height: ${props => props.$size}px;
    border-radius: ${props => (props.$shape === 'rounded' ? '10px' : '50%')};
    ${props =>
        props.$disabled &&
        css`
            opacity: 0.5;
        `}
    ${props =>
        props.$clickable &&
        css`
            cursor: pointer;
        `}
`;

// Фон, а не <img>: из кэша красится синхронно, без мигания.
export const ImageLayer = styled.div`
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;

// Заглушка — в самом низу (z-index: -1), чтобы картинка и бейджи/children рендерились
// поверх неё. isolation: isolate на AvatarRoot держит этот слой внутри аватара.
export const FallbackLayer = styled.div<{ $bgColor?: string }>`
    position: absolute;
    inset: 0;
    z-index: -1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: inherit;
    overflow: hidden;
    background: ${props => props.$bgColor ?? 'transparent'};
`;

export const BadgeLayer = styled.div`
    position: absolute;
    inset: 0;
    pointer-events: none;
`;
